<template>
  <mailbox-settings-layout :name="name">
    <el-card class="mailbox-settings-email-signature">
      <template #header>
        <h3>Email Signature</h3>
      </template>
      <entity-settings-loading v-if="isLoading" />
      <template v-else> 
        <div>
          <p>
            Add an <strong>Email Signature</strong> to replies or new conversations sent from this mailbox.
            You can insert the replier's name as a variable under the "Insert Variable" option.
          </p>
          <div class="dd-divider" />
          <el-form label-position="top">
            <el-form-item >
              <editor
                v-model="signature"
                :disabled="isSubmitting"
                :variables="signatureVars"
              />
            </el-form-item>
          </el-form>
          <dd-button
            :is-loading="isSubmitting"
            :color="ColorAssistant.MailboxColor"
            class="float-right"
            size="large"
            @click="save"
          >Save Changes</dd-button>
          <div class="clearfix" />
        </div>
      </template>
    </el-card>
  </mailbox-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import { INameAndDescription } from '@/api/types/response.types'

export default defineComponent({
  name: 'MailboxSettingsEmailSignature',

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      name: '',
      signatureVars: [] as INameAndDescription[],
      signature: '',
    }
  },

  head(): any {
    return {
      title: `Email Signature - ${this.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },

  async created() {
    this.isLoading = true
    await this.getEmailSignatureInfo()
    this.isLoading = false
  },

  methods: {
    async getEmailSignatureInfo() {
      try {
        const response = await MailboxesAPI.get_OutgoingSignatureTemplate(
          this.id,
        )
        this.name = response.name
        this.signatureVars = response.listSignatureVars
        this.signature = response.signature
      } catch (error) {
        this.$error.emit(error)
      }
    },

    async save() {
      try {
        this.isSubmitting = true
        const response = await MailboxesAPI.post_OutgoingSignatureTemplate(
          this.id,
          this.signature,
        )
        this.$messaging.showSuccess(response.message)
        // Fetch again for any server HTML cleanup updates
        await this.getEmailSignatureInfo()
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
</script>

<style lang="scss">
.mailbox-settings-email-signature {
  .in-text {
    font-size: 14px;
    padding: 0 2px;
  }

  .replies-list {
    padding-bottom: 20px;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    &__empty-message {
      color: var(--color-text-third);
    }
  }
}
</style>
